import { parseFile } from "../components/ParseFile/ParseFile";

export const getImageLink = (url: string) => {
   if (url?.includes("drive.google")) {
      return `https://drive.google.com/thumbnail?id=${parseFile(url)}`;
   } else {
      return url;
   }
};
